import PropTypes from 'prop-types';

import Button from '@zenbusiness/zui/Button';
import Heading from '@zenbusiness/zui/Heading';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from '../../AccountSettings.styles';

const OptOutMessaging = ({ isOptedOut, onClickOptOut }) => {
  if (isOptedOut) {
    return (
      <Text component="p" size="sm" weight="regular" color="primary">
        We won’t share your information with any of our partners. You can opt back in, via choosing an offer from our
        partners, at any&nbsp;time.
      </Text>
    );
  }

  return (
    <Styled.OptPartner>
      <Text component="p" size="sm" weight="regular" color="primary">
        We only work with companies we know and trust to provide valuable small business services for our customers. But
        you can always opt out if you don’t want to connect with our partners.
      </Text>

      <Button color="primary" onClick={onClickOptOut} variant="outlined">
        Opt out
      </Button>
    </Styled.OptPartner>
  );
};

OptOutMessaging.propTypes = {
  isOptedOut: PropTypes.bool, // this can definitely be empty as the endpoint returns null sometimes
  onClickOptOut: PropTypes.func.isRequired,
};

const ConnectWithPartners = ({ account: { allPartnerOptOut: isOptedOut } = {}, onClickOptOut, loading }) => (
  <Stack gap={{ xs: 3, sm: 4 }}>
    <Heading component="h2" size="lg">
      {isOptedOut ? 'You’re opted out of our partner program' : 'Connect with our partners'}
    </Heading>
    {loading ? <Skeleton height="64px" /> : <OptOutMessaging isOptedOut={isOptedOut} onClickOptOut={onClickOptOut} />}
  </Stack>
);

ConnectWithPartners.propTypes = {
  account: PropTypes.shape({}).isRequired,
  onClickOptOut: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ConnectWithPartners;
